import TableList from "@components/templates/tablelist";
import { HttpAccessGroupList, HttpDelAccessGroup, HttpGetSupplierByContextId } from "@/service/ucadm";
import compUpdate from "./update";
import compSupplierUser from './supplierUser'
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            // formData: {},
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true },
            supplierList: []
        };
    },
    components: {
        compUpdate,
        compSupplierUser
    },
    created () {
        HttpGetSupplierByContextId().then(res => {
            this.supplierList = res.data.map((item) => {
                return {
                    value: item.id,
                    label: item.name,
                };
            });
        })
    },
    methods: {
        ajaxRequest: HttpAccessGroupList,
        interceptRequest: (request) => {
            let { search, ...data } = {
                ...request,
            }
            let { supplierId, ...searchData} = {
                ...search
            }
            return {
                ...data,
                search: {
                    ...searchData
                },
                module: 'Supplier',
                resourceIds: supplierId
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "add" },
                        title: "添加分组",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "edit" },
                        title: "编辑分组",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "删除该分组",
                        ajaxRequest: HttpDelAccessGroup
                    };
                    break;
                case 'user':
                    console.log(params)
                    this.operate = {
                        show: true,
                        params: { id: params },
                        title: '关联用户',
                        component: 'compSupplierUser',
                        width: 1000,
                        showFooter: false
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: "edit"
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "del"
                },
                {
                    label: '查看关联用户',
                    show: true,
                    params: id,
                    operate: 'user'
                }
            ];
        }
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: "添加分组",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "名称",
                    tag: "vInput",
                    key: "CN_displayName",
                    show: true,
                    style: {
                        'width': '200px'
                    }
                },
                {
                    label: '供应商',
                    tag: 'Select',
                    key: 'supplierId',
                    show: true,
                    options: this.supplierList,
                    width: 200,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: {
                        'width': '200px'
                    }
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: '供应商分组序号',
                    key: 'id'
                },
                
                {
                    title: "供应商分组名称",
                    key: "displayName",
                    sortable: true
                },
                // {
                //     title: '分组状态',
                //     key: ''
                // },
                {
                    title: "分组描述",
                    key: "description"
                },
                {
                    title: "更新时间",
                    key: "updatedAt"
                }
            ];
        }
    }
};
